// To be Updated for Qmee Surveys

// import { SurveyType } from 'components/molecules/SurveyItem/SurveyItem';
// import useFormatCurrency from 'hooks/useFormatCurrency';
import React from 'react';
// import { formatCurrency } from '../../../utils/locale';
// import { SurveyItem_survey$data } from '../../molecules/SurveyItem/__generated__/SurveyItem_survey.graphql';
// import { SCREENER_SURVEY } from '../pages';

export interface SurveyType {
  id: string;
  duration: number;
  reward: { cents: number; formatted: string; currency: string } | null;
  tags?: string[];
  title?: string;
  supportId?: string;
  studyId?: string;
  baseReward?: any;
  lockedInfo?: any;
  status?: string;
  startedAt?: any;
  statusDescription?: string;
  imageUrl?: string;
  iconUrl?: string;
  url?: string | null;
  fraudType?: any;
  durationDetails?: {
    min: number;
    median: number;
    max: number;
    providerDuration: number;
  };
  adminData?: any;
}

interface SurveySettings {
  id: string;
  title?: string;
  reward: number | null;
  duration: number;
  //   lockedInfo?: SurveyType['lockedInfo'];
}

// ts-ignore
export function createFakeSurvey(overwrites: Partial<SurveyType> = {}): SurveyType {
  return {
    id: 'default-1',
    duration: 3,
    reward: null,
    tags: ['locked'],
    title: 'publicSurveys.default.title',
    supportId: 'mobile-app-static-signup',
    studyId: 'mobile-app-static-signup',
    baseReward: null,
    lockedInfo: null,
    status: 'AVAILABLE',
    startedAt: null,
    statusDescription: 'AVAILABLE',
    imageUrl: 'https://cdn.assets.qmee.com/images/57-385cbc592f275441abaada185b52562a.jpg',
    iconUrl: 'https://www.qmee.com/favicon.svg',
    url: null,
    fraudType: null,
    // durationDetails: {
    //   min: overwrites.duration || 2,
    //   median: overwrites.duration || 2,
    //   max: overwrites.duration || 2,
    //   providerDuration: overwrites.duration || 2,
    // },
    durationDetails: {
      min: 2,
      median: 2,
      max: 2,
      providerDuration: 2,
    },
    adminData: null,
    ...overwrites,
  };
}

export function useStaticSurveys(): SurveyType[] {
  //   const formatCurrency = useFormatCurrency();
  return React.useMemo(
    () => {
      function createMoneyAmount(
        cents: number,
      ): { readonly formatted: string; readonly cents: number; readonly currency: string } | null {
        //   const formatted = formatCurrency(cents);
        const formatted = 'sfsdf'; // TODO fix formatCurrency usage
        return {
          formatted,
          cents,
          currency: 'USD',
        };
      }
      return [
        createFakeSurvey({
          id: 'static-prescreener',
          reward: null,
          duration: 3,
          title: 'publicSurveys.staticPrescreener.title',
          tags: ['screener', 'hot'],
          // url: SCREENER_SURVEY.path,
          imageUrl: 'https://cdn.assets.qmee.com/images/57-385cbc592f275441abaada185b52562a.jpg',
        }),
        createFakeSurvey({
          id: 'static-1',
          reward: createMoneyAmount(83),
          duration: 8,
          title: 'publicSurveys.static1.title',
          tags: ['hot'],
          imageUrl: 'https://cdn.assets.qmee.com/images/274-e0ca74e86d2da37ac4db8a22661f9eb9.jpg',
        }),
        createFakeSurvey({
          id: 'static-2',
          reward: createMoneyAmount(114),
          duration: 8,
          title: 'publicSurveys.static2.title',
          tags: ['hot', 'new'],
          imageUrl: 'https://cdn.assets.qmee.com/images/147-b2f34e7996dd3ceda5247599aaea4751.jpg',
        }),
        createFakeSurvey({
          id: 'static-3',
          reward: createMoneyAmount(54),
          duration: 9,
          title: 'publicSurveys.static3.title',
          tags: ['new'],
        }),
        createFakeSurvey({
          id: 'static-4',
          reward: createMoneyAmount(92),
          duration: 5,
          title: 'publicSurveys.static4.title',
          tags: ['webcam'],
          imageUrl: 'https://cdn.assets.qmee.com/images/152-07ecd88e425a4c68d385a1be4684a6e2.jpg',
        }),
        createFakeSurvey({
          id: 'static-5',
          reward: createMoneyAmount(32),
          duration: 12,
          title: 'publicSurveys.static5.title',
          imageUrl: 'https://cdn.assets.qmee.com/images/181-cb75b2c49b800304d96273288005e4ac.jpg',
        }),
        createFakeSurvey({
          id: 'static-6',
          reward: createMoneyAmount(45),
          duration: 7,
          title: 'publicSurveys.static6.title',
          imageUrl: 'https://cdn.assets.qmee.com/images/181-cb75b2c49b800304d96273288005e4ac.jpg',
        }),
      ];
    } /* [formatCurrency] */,
    [],
  );
}
